import { useState, useEffect, useCallback } from 'react';
import './newPostPage.scss';
import ReactQuill from 'react-quill-new';
import { City, Country, State } from 'country-state-city';
import Select from 'react-select';
import { useSubmitStore } from '../../lib/submitStore';
import 'react-quill/dist/quill.snow.css';
import apiRequest from '../../lib/apiRequest';
import UploadWidget from '../../components/uploadWidget/UploadWidget';
import { useNavigate } from 'react-router-dom';
import categoriesData from '../../components/category/CategoriesData';

function NewPostPage() {
  //Country
  const [selectedCountry, setSelectedCountry] = useState('');
  const [country, setCountry] = useState('');
  const [selectedState, setSelectedState] = useState(null);
  const [state, setState] = useState('');
  const [selectedCity, setSelectedCity] = useState(null);
  const [city, setCity] = useState('');
  const [add, setAdd] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState();

   //Button block
 const isSubmitting = useSubmitStore((state) => state.isSubmitting);
const setIsSubmitting = useSubmitStore((state) => state.setIsSubmitting);
  //

  var countryData = Country.getAllCountries();

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      const { latitude, longitude } = pos.coords;
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
      fetch(url)
        .then((res) => res.json())
        .then((data) => setAdd(data.address.country_code));
    });
  }, []);

  const countries = countryData.map((country) => ({
    value: country.isoCode,
    label: country.name,
    latitude: country.latitude,
    longitude: country.longitude,
  }));

  useEffect(() => {
    if (add) {
      const foundCountry = countries.find(
        (el) => el.value.toLowerCase() === `${add}`.toLowerCase()
      );
      if (foundCountry) {
        setSelectedCountry(foundCountry);
      }
    }
  }, [add, countryData]);

  useEffect(() => {
    setCountry(selectedCountry.label);
  }, [selectedCountry]);

  const handleChangeCountry = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setCountry(selectedOption.label);
    setLatitude(selectedOption.latitude);
    setLongitude(selectedOption.longitude);
    setSelectedState(null);
    setSelectedCity(null);
  };

  const states = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        value: state.isoCode,
        label: state.name,
        latitude: state.latitude,
        longitude: state.longitude,
      }))
    : [];

  const handleChangeState = (selectedOption) => {
    setSelectedState(selectedOption);
    setState(selectedOption.label);
    setLatitude(selectedOption.latitude);
    setLongitude(selectedOption.longitude);
    setSelectedCity(null);
  };

  const cities = selectedState
    ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
        (city) => ({
          value: city.name,
          label: city.name,
          latitude: city.latitude,
          longitude: city.longitude,
        })
      )
    : [];

  const handleChangeCity = (selectedOption) => {
    setSelectedCity(selectedOption);
    setCity(selectedOption.label);
    setLatitude(selectedOption.latitude);
    setLongitude(selectedOption.longitude);
  };
  //Country end
 
  //Title check
  const [title, setTitle] = useState('');
  const [isLimitExceeded, setIsLimitExceeded] = useState(false);
  const maxLength = 50;

  const handleChange = (event) => {
    const inputTitle = event.target.value;

    if (inputTitle.length <= maxLength) {
      setTitle(inputTitle);
      setIsLimitExceeded(false);
    } else {
      setIsLimitExceeded(true);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault(); // Отменяем стандартное поведение вставки

    // Получаем текст из буфера обмена
    const pastedText = event.clipboardData.getData('text');

    // Используем setTimeout, чтобы дождаться вставки текста в поле ввода
    setTimeout(() => {
      const currentText = event.target.value;
      const newText = currentText + pastedText;

      if (newText.length > maxLength) {
        // Если длиннее, обрезаем текст
        setTitle(newText.slice(0, maxLength));
        setIsLimitExceeded(true);
      } else {
        // Если в пределах лимита, просто устанавливаем состояние
        setTitle(newText);
        setIsLimitExceeded(false);
      }
    }, 0);
  };
  //Title check end

  //Product categories
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setSelectedSubCategory(null);
    setSelectedOptions({
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      option5: null,
      option6: null,
      option7: null,
    });
  };

  const handleSubCategoryChange = (selectedOption) => {
    setSelectedSubCategory(selectedOption);
    setSelectedOptions({
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      option5: null,
      option6: null,
      option7: null,
    }); // Инициализируем опции
  };
  //Conditions
  const conditions = [
    { value: 'used', label: 'Used' },
    { value: 'new', label: 'New' },
  ];
  const [selectedCondition, setSelectedCondition] = useState(conditions[0]);
  const handleConditionChange = (selectedCondition) => {
    setSelectedCondition(selectedCondition);
  };
  //Conditions end

  const categoryOptions = categoriesData.map((category) => ({
    value: category.id,
    name: category.name,
    img: category.img.src,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          className={category.img.className}
          src={category.img.src}
          alt={category.img.alt}
          style={{ marginRight: '10px' }}
        />
        {category.name}
      </div>
    ),
  }));

  const handleOptionChange = (optionKey) => (selectedOption) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [optionKey]: selectedOption.value,
    }));
  };

  const selectedCategoryData = categoriesData.find(
    (category) => category.id === selectedCategory?.value
  );
  const subCategoryOptions = selectedCategoryData
    ? selectedCategoryData.subcategories.map((sub) => ({
        value: sub.id,
        name: sub.name,
        img: sub.img.src,
        label: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              className={sub.img.className}
              src={sub.img.src}
              alt={sub.img.alt}
              style={{ marginRight: '10px' }}
            />
            {sub.name}
          </div>
        ),
      }))
    : [];
  const selectedSubCategoryData =
    selectedCategoryData &&
    selectedCategoryData.subcategories.find(
      (sub) => sub.id === selectedSubCategory?.value
    );

  const options = selectedSubCategoryData?.options
    ? Object.entries(selectedSubCategoryData.options).map(([key, option]) => ({
        key,
        name: option.name,
        values: option.values
          ? option.values.map((value) => ({ value, label: value }))
          : [],
      }))
    : [];

  const allOptions = options.reduce((acc, option, index) => {
    const num = index + 1;
    acc[`option${num}`] = selectedOptions[`option${num}`] || null;
    acc[`option${num}name`] = option.name || null;
    return acc;
  }, {});

  //Product categories end
  const [value, setValue] = useState('');
  const [images, setImages] = useState([]);
  const [error, setError] = useState('');
  const [uploadSignature, setUploadSignature] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchSignature = useCallback(async () => {
    try {
      const response = await apiRequest.post('/posts/getUploadToken');
      setUploadSignature(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching upload token:', error);
    }
  }, []);
  useEffect(() => {
    fetchSignature();
  }, [fetchSignature]);

  const handleImageDelete = useCallback(async (public_id) => {
    try {
      await apiRequest.post('/posts/deleteImage', { public_id });
      setImages((prevImages) =>
        prevImages.filter((img) => img.public_id !== public_id)
      );
      alert('Image successfully deleted!');
    } catch (error) {
      console.error('Error deleting image:', error);
      alert('Error deleting image!');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); //Block button
    const formData = new FormData(e.target);
    const inputs = Object.fromEntries(formData);

    try {
      const res = await apiRequest.post('/posts', {
        postData: {
          title: inputs.title,
          price: parseInt(inputs.price),
          country: country,
          region: state,
          city: city,
          condition: selectedCondition.value,
          category: selectedCategory ? selectedCategory.name : null, 
          categoryimg: selectedCategory ? selectedCategory.img : null, 
          subcategory: selectedSubCategory ? selectedSubCategory.name : null, 
          subcategoryimg: selectedSubCategory ? selectedSubCategory.img : null, 
          ...allOptions,
          latitude: inputs.latitude,
          longitude: inputs.longitude,
          images: images,
        },
        postDetail: {
          desc: value,
        },
      });
      navigate('/' + res.data.id);
    } catch (err) {
      console.log(err);
      setError(error);
    } finally {
    setIsSubmitting(false); // Unblock button
  }
  };

  const customComponents = (props) => {
    return (
      <div>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={(e) => e.stopPropagation()}
        />
        <label>{props.label}</label>
      </div>
    );
  };

  return (
    <div className="newPostPage">
      <div className="formContainer">
        <h1>New ad creating</h1>
        <div className="wrapper">
          <form id="newPostForm" onSubmit={handleSubmit}>
            <div className="item">
              <label htmlFor="title">Title</label>
              <input
                id="title"
                name="title"
                type="text"
                value={title}
                onChange={handleChange}
                onPaste={handlePaste}
              />
              {isLimitExceeded && (
                <div style={{ color: 'red' }}>
                  Character limit exceeded (max. 50 characters)
                </div>
              )}
            </div>
            <div className="item">
              <label htmlFor="condition">Condition</label>
              <Select
                name="condition"
                value={selectedCondition}
                onChange={handleConditionChange}
                options={conditions}
              />
            </div>
            <div className="item">
              <label htmlFor="price">Price</label>
              <input id="price" name="price" type="number" />
            </div>
            <div className="item">
              <label htmlFor="country">Country</label>
              <Select
                value={selectedCountry}
                onChange={handleChangeCountry}
                options={countries}
                placeholder="Select Country"
              />
            </div>
            <div className="item">
              <label htmlFor="region">Region</label>

              <div>
                <Select
                  value={selectedState}
                  onChange={handleChangeState}
                  options={states}
                  placeholder="Select Region"
                />
              </div>
            </div>
            <div className="item">
              <label htmlFor="city">City</label>

              <div>
                <Select
                  value={selectedCity}
                  onChange={handleChangeCity}
                  options={cities}
                  placeholder="Select City"
                />
              </div>
            </div>
            <div className="item">
              <label htmlFor="categories">Categories</label>
              <div>
                <Select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  options={categoryOptions}
                  placeholder="Select Category"
                />
              </div>
            </div>

            {selectedCategory && subCategoryOptions.length > 0 && (
              <div className="item">
                <label htmlFor="subcategory">Subcategory</label>
                <div>
                  <Select
                    value={selectedSubCategory}
                    onChange={handleSubCategoryChange}
                    options={subCategoryOptions}
                    placeholder="Choose..."
                  />
                </div>
              </div>
            )}
            {selectedSubCategory && options.length > 0 && (
              <div className="options">
                {options.map(({ key, name, values }) => (
                  <div key={key} className="option_item">
                    <label>{name}</label>
                    <Select
                      options={values}
                      components={customComponents}
                      onChange={handleOptionChange(key)}
                      placeholder="All"
                    />
                  </div>
                ))}
              </div>
            )}

            <div className="item description">
              <label htmlFor="desc">Description</label>
              <ReactQuill theme="snow" onChange={setValue} value={value} />
            </div>
            <div style={{ display: 'none' }}>
              <label htmlFor="latitude">Latitude</label>
              <input
                id="latitude"
                name="latitude"
                type="text"
                defaultValue={latitude}
              />
            </div>
            <div style={{ display: 'none' }}>
              <label htmlFor="longitude">Longitude</label>
              <input
                id="longitude"
                name="longitude"
                type="text"
                defaultValue={longitude}
              />
            </div>
            <button className="sendButton" disabled={isSubmitting}>{isSubmitting ? 'Posting...' : 'Add'}</button>
            {error && <span>error</span>}
          </form>
        </div>
      </div>
      <div className="sideContainer">
        <h1>Images:</h1>
        {images.map((image, index) => (
          <div key={index} className="imageContainer">
            <img src={image.url} alt="Uploaded" />
            <button
              onClick={() => {
                handleImageDelete(image.public_id);
              }}
            >
              X
            </button>
          </div>
        ))}
        <UploadWidget
          uwConfig={{
            multiple: true,
            cloudName: 'dge3e7ie3',
            uploadPreset: 'foxads',
            sources: ['local', 'url', 'dropbox', 'google_drive'],
            folder: 'posts',
            secure: true, // Используем secure атрибут чтобы включить только безопасные куки
            sameSite: 'None',
            transformations: [
              {
                fetch_format: 'webp',
                quality: 'auto',
              },
            ],
          }}
          setState={setImages}
        />
      </div>
    </div>
  );
}

export default NewPostPage;
